export interface ApiErrorContext {
  url: string;
  method: string;
  params?: Record<string, unknown>;
  body?: unknown;
  /** 클라 생성 W3C trace context — 실패 로그와 ingress/gateway 로그의 조인 키 */
  trace_id?: string;
  span_id?: string;
}

export class ApiError extends Error {
  constructor(
    public message: string,
    public status: number,
    public code?: string,
    public context?: ApiErrorContext,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export const isApiError = (error: unknown): error is ApiError => {
  return (
    error instanceof Error && typeof (error as ApiError).status === 'number'
  );
};

export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'NETWORK_ERROR',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  SERVER_ERROR: 'SERVER_ERROR',
  TIMEOUT: 'TIMEOUT',
  UNKNOWN: 'UNKNOWN',
} as const;
